import { MUIIcon, ProgressIndicator } from "../../widgets"
import React, { useEffect, useState } from "react"

import { ContactCard } from "./ContactCard"
import { useAuth } from "../../../modules/auth"
import { useContactConnections } from "./useContactConnections"
import { useSwitchUserEntityMutation } from "../../services/auth"

export const SwitchSiteEntity = ({ children }: { children?: React.ReactNode }) => {
    const { user } = useAuth()

    if (!user) {
        return <><ProgressIndicator /></>
    }

    switch (user.role) {
        case "Father":
        case "Mother":
        case "Guardian":
            return <SelectContactConnection>{children}</SelectContactConnection>
        default:
            return <>{children}</>
    }
}

export const SelectContactConnection = ({ children }: { children?: React.ReactNode }) => {
    const { user, siteId } = useAuth()
    const { connections, entityId, selectEntityId } = useContactConnections()
    const [connectionId, setConnectionId] = useState("")
    const [loadingContactId, setLoadingContactId] = useState("")
    const [switchUserEntity] = useSwitchUserEntityMutation()

    useEffect(() => {
        if (!user || !siteId || !connectionId) return;

        setLoadingContactId(connectionId);
        switchUserEntity({ userName: user?.userName, switchUserEntityId: connectionId, portalId: siteId })
            .unwrap()
            .then((result) => {
                selectEntityId(connectionId);
            })
            .catch(err => {
                console.log((err.data.message, 'An error was encountered while attempting to impersonate the user.'));
            }).finally(() => {
                setLoadingContactId('')
                setConnectionId('')
            })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId])

    if (!entityId && connections) {
        return <>
            <h1 className="mb-5"><MUIIcon iconName="PersonSearchOutlined" className="fs-2x" /> Pick a Profile</h1>
            <div className="d-flex flex-row flex-wrap gap-3">
                {connections.map((connection) => <React.Fragment key={connection.id}>
                    <button type="button" className="btn p-0 m-0"
                        onClick={() => setConnectionId(connection.contactId)}>
                        <ContactCard
                            loadingContactId={loadingContactId}
                            className="btn btn-light"
                            contactId={connection.contactId}
                        />
                    </button>
                </React.Fragment>)}
            </div>
        </>
    }

    return <>
        {children}
    </>
}

